import { noticeRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const noticeRoute: RouteObject[] = [
  {
    path: noticeRoutePaths.list.path,
    async lazy() {
      const NoticeList = await import('@/pages/notice/NoticeList');
      return { Component: NoticeList.default };
    },
  },
  {
    path: noticeRoutePaths.detail.path,
    async lazy() {
      const NoticeDetail = await import('@/pages/notice/NoticeDetail');
      return { Component: NoticeDetail.default };
    },
  },
];
